import { Errors } from 'gleblu-socket-api';
import { Action, createAction } from 'redux-act';

import PlaceUser from '../../../models/interfaces/PlaceUser';
import FetchPayload from '../FetchPayload';

export interface FetchEmployeeInvitationPayload extends FetchPayload {
  token: string;
}
export const fetchEmployeeInvitation = createAction<FetchEmployeeInvitationPayload>('FETCH_EMPLOYEE_INVITATION');
export type FetchEmployeeInvitationActionType = Action<FetchEmployeeInvitationPayload>;

export interface EmployeeInvitationFetchedPayload {
  token: string;
  errorType?: Errors;
  placeUser: PlaceUser;
}
export const employeeInvitationFetched = createAction<EmployeeInvitationFetchedPayload>('EMPLOYEE_INVITATION_FETCHED');

export interface EmployeeInvitationFetchFailedPayload {
  token: string;
}
export const employeeInvitationFetchFailed = createAction<EmployeeInvitationFetchFailedPayload>('EMPLOYEE_INVITATION_FETCH_FAILED');

export type EmployeeInvitationFetchResponsePayload = EmployeeInvitationFetchedPayload | EmployeeInvitationFetchFailedPayload;
